import { Controller } from "@hotwired/stimulus"

// "View report" overlay: shows the Turnitin Cloud Viewer in an on-page iframe.
// Viewer URLs are ephemeral one-shots, so the iframe src points at our own
// redirecting endpoint and is (re)set on every open and cleared on close.
// The overlay element itself is data-turbo-permanent — live morph refreshes of
// the submission page can't tear it down mid-reading — and it carries its own
// backdrop, so no Bootstrap modal (whose body-level backdrop a morph would eat).
export default class extends Controller {
  static targets = ["overlay", "frame"]
  static values = { url: String }

  open(event) {
    event.preventDefault()
    this.frameTarget.src = this.urlValue
    this.overlayTarget.classList.remove("d-none")
  }

  close() {
    if (this.overlayTarget.classList.contains("d-none")) return

    this.overlayTarget.classList.add("d-none")
    this.frameTarget.src = ""
  }

  // Close only when the dimmed area itself is clicked, not the report panel.
  backdropClose(event) {
    if (event.target === this.overlayTarget) this.close()
  }
}
